export default __webpack_public_path__ + "static/email-icon-4a36a2f2945233f9cca13015d4861763.png";